var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_order_details)?_c('p',{staticClass:"amount"},[_vm._v(" Cantidad: "+_vm._s(_vm.article.pivot.amount)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }